import { useState } from "react";
import PhoneInput, { type Country } from "react-phone-number-input";
import "react-phone-number-input/style.css";


export function PhoneField({
  name,
  placeholder,
  idPrefix,
  variant = "light",
}: {
  name: string;
  placeholder: string;
  idPrefix?: string;
  variant?: "light" | "dark";
}) {
  const [value, setValue] = useState<string | undefined>();
  const [country, setCountry] = useState<Country>("US");




  const inputBase =
    variant === "dark"
      ? "border border-border bg-transparent text-foreground placeholder:text-muted-foreground/70"
      : "border border-black/15 bg-white text-ink placeholder:text-black/40";

  return (
    <div className={`phone-field phone-field--${variant} w-full`}>
      <PhoneInput
        international
        defaultCountry={country}
        country={country}
        onCountryChange={(c) => c && setCountry(c)}
        value={value}
        onChange={setValue}
        placeholder={placeholder}
        id={idPrefix ? `${idPrefix}-${name}` : name}
        name={name}
        numberInputProps={{
          required: true,
          className: `w-full px-4 py-3 font-light outline-none transition focus:border-gold ${inputBase}`,
        }}
      />
    </div>
  );
}
